module.exports = __webpack_public_path__ + "img/logo.557fbec1.png";